module.exports = __webpack_public_path__ + "img/tacos.4b03cc17.jpg";